export default __webpack_public_path__ + "static/media/ctg-7a.7590820c.webp";